// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, is, maybe, objectOf, withRecursion } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type {
  TemplateComponentHeaderFormatText,
  TemplateComponentHeaderFormatMedia,
} from "../engagementAppGroupIdWhatsAppMessageTemplates/types";

// Response validators use "example" (singular) instead of "examples" (plural) to match the API response
const isTemplateComponentHeaderFormatText = is<TemplateComponentHeaderFormatText>("text");
const isTemplateComponentHeaderFormatMedia = enumOf<TemplateComponentHeaderFormatMedia>(
  "image",
  "video",
  "document"
);

const isWhatsAppMessageTemplateResponseHeader = objectOf({
  header_format: anyOf(isTemplateComponentHeaderFormatText, isTemplateComponentHeaderFormatMedia),
  text: anyOf(string, is(null)),
  example: arrayOf(string),
});

const isWhatsAppMessageTemplateResponseBody = objectOf({
  text: string,
  example: arrayOf(string),
});

const isWhatsAppMessageTemplateResponseFooter = objectOf({
  text: string,
});

const isWhatsAppMessageTemplateResponseButton = objectOf({
  button_type: string,
  text: string,
  url: maybe(string),
  phone_number: maybe(string),
  example: arrayOf(string),
});

const isWhatsAppMessageTemplateResponseComponents = withRecursion((isWhatsAppMessageTemplateResponseComponents) =>
  objectOf({
    header: maybe(isWhatsAppMessageTemplateResponseHeader),
    body: maybe(isWhatsAppMessageTemplateResponseBody),
    footer: maybe(isWhatsAppMessageTemplateResponseFooter),
    buttons: maybe(arrayOf(isWhatsAppMessageTemplateResponseButton)),
    carousel_cards: maybe(arrayOf(isWhatsAppMessageTemplateResponseComponents)),
  })
);

const isWhatsAppMessageTemplateResponsePrefillContent = withRecursion(
  (isWhatsAppMessageTemplateResponsePrefillContent) =>
    objectOf({
      header_liquid_variables: maybe(arrayOf(string)),
      body_liquid_variables: maybe(arrayOf(string)),
      button_liquid_variables: maybe(arrayOf(string)),
      header_media_uri: maybe(string),
      header_media_type: maybe(string),
      carousel_cards: maybe(arrayOf(isWhatsAppMessageTemplateResponsePrefillContent)),
    })
);

const isWhatsAppMessageTemplateResponse = objectOf({
  id: string,
  app_group_id: string,
  name: string,
  language: string,
  category: string,
  external_account_id: string,
  components: isWhatsAppMessageTemplateResponseComponents,
  prefill_content: isWhatsAppMessageTemplateResponsePrefillContent,
  click_tracking_enabled: maybe(boolean),
  custom_domain: maybe(string),
  is_draft: maybe(boolean),
});

export const isGetEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountIdResult = objectOf({
  templates: arrayOf(isWhatsAppMessageTemplateResponse),
});
